import { StoreState } from "..";

export const getSearchCriteria = (state: StoreState) => state.searchCriteria;
